import { useEffect, useState } from "react";
import { firebaseApp } from "../config/firebaseAuthProvider";
import { getAuth } from "firebase/auth";
import { getDatabase, ref, onValue } from "firebase/database";

const useFirebaseAuth = () => {
	const [user, setUser] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [token, setToken] = useState(null);

	useEffect(() => {
		let metadataUnsubscribe = null;

		const refreshToken = (token, hasuraClaim, user) => {
			if (!hasuraClaim) {
				// Check if refresh is required.
				const metadataRef = ref(getDatabase(firebaseApp), "metadata/" + user.uid + "/refreshTime");

				metadataUnsubscribe = onValue(metadataRef, async (data) => {
					if (!data.exists()) return;
					// Force refresh to pick up the latest custom claims changes.
					const token = await user.getIdToken(true);
					setToken(token);
				});
			} else {
				setToken(token);
				localStorage.setItem("token", token);
			}
		};

		const unsubscribe = getAuth(firebaseApp).onAuthStateChanged(async (user) => {
			if (user) {
				const token = await user.getIdToken();
				const idTokenResult = await user.getIdTokenResult();
				const hasuraClaim = idTokenResult.claims["https://hasura.io/jwt/claims"];

				setUser(user);
				refreshToken(token, hasuraClaim, user);
			} else {
				setUser(null);
				localStorage.setItem("token", null);
			}
			setIsLoading(false);
		});

		const cleanup = () => {
			unsubscribe();
			if (metadataUnsubscribe && typeof metadataUnsubscribe === "function") {
				metadataUnsubscribe();
			}
		};

		return () => cleanup();
	}, []);

	return { user, token, isLoading };
};

export default useFirebaseAuth;
